/**
 * 将 componentData 规范为 kv / kv_assert 行数组。
 * 非数组（含误配成 dict 的情况）视为空表，避免 [...dict] 抛错。
 * :param {*} value: 原始值
 * :returns {Array}
 */
export function asKvRows(value) {
  return Array.isArray(value) ? value : [];
}
